module.exports = __webpack_public_path__ + "static/media/Org-User.9c02d35b.jpg";